export default "__VITE_ASSET__yBamEPVz__"